import { BlockScheduleDateInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const BlockScheduleDateInputSchema: z.ZodType<BlockScheduleDateInput> =
  z.object({
    date: z.string(),
    blocked: z.boolean(),
  });
